/**
 * Enum trạng thái ghi sổ
 */
export default {
  Writed: 1, // Ghi sổ
  NotWrited: 0, // Chưa ghi sổ
};
